import React, {useEffect, useState} from 'react'
import {useHistory} from 'react-router-dom'
import {useDispatch, useSelector} from 'react-redux'
import { v4 as uuidv4 } from 'uuid'


import DashboardHeader from './dashboardHeader'
import DashBoardContainer from '../../components/containers/dashboardContainer'
import TextField from '../../components/textField'
import VerticalSelectField from '../../components/selectField/verticalSelectField'
import {
    fetchProvince, 
    fetchDistricts,
    fetchSectors,
    fetchCells,
    fetchVillages,
    editMembership
} from '../../actions'
import {
    submitIndividualApplication,
    updateIndividualApplication,
    fetchIndividualApplicationReport
} from '../../actions'
import {
    SUBMIT_APPLICATION_ID,
    EDIT_MEMBERSHIP_LOADING_ID
} from '../../store/loaders'
import Residence from '../../components/residence'
import CountrySelector from '../../components/countrySelector'
import TextArea from '../../components/textarea'
import validator from 'validator'
import { normalizeInput } from '../../utility/utils'




const ApplicationContactDetails = (props)=>{
    const history = useHistory()
    const dispatch = useDispatch()

    

    const [requestId, setRequestId] = useState('')
    const [applicationDetails,
        setApplicationDetails] = useState({})

    const [emailError, setEmailError] = useState(false)
    const [emailHelperText, setEmailHelperText] = useState('')

    const [secondaryEmailError, setSecondaryEmailError] = useState(false)
    const [secondaryEmailHelperText, setSecondaryEmailHelperText] = useState('')
    const [hasFected, setHasFetched] = useState(false)

    const [phoneError, setphoneError] = useState({
        primaryPhone: false,
        secondaryPhone: false
    })

    const [phoneErrorText, setPhoneErrorText] = useState({
        primaryPhone: '',
        secondaryPhone: ''
    })
    

    const apiResponse = useSelector(state=>{
        const {
            provinces, 
            districts, 
            sectors, 
            villages, 
            cells, 
            loader,
            hasUpdatedIndividualApplication,
            individualApplicationReport,
            hasEditedMembership
        } = state
        const {province} = provinces
        const {district} = districts
        const {sector} = sectors
        const {village} = villages
        const {cell} = cells
        const {isLoading} = loader[SUBMIT_APPLICATION_ID] || {isLoading: false}
        const {application} = individualApplicationReport
        const {message} = hasUpdatedIndividualApplication
        const editLoader = loader[EDIT_MEMBERSHIP_LOADING_ID] || false
        const {edited} = hasEditedMembership



        return{
            province,
            district,
            sector,
            village,
            cell,
            isLoading,
            application,
            message,
            editLoader,
            edited
        }
    })

    const actionLoader = apiResponse.isLoading
    const applicationId = apiResponse.application?.applicationId || apiResponse.application?.id
    const appId = props.location.state && props.location.state.application?.id
    const isMember = props.location.state && props.location.state?.isMember



    useEffect(()=>{
        if(apiResponse.application){
            setApplicationDetails({
                ...apiResponse.application,
            })
            if(!hasFected){
                if(apiResponse.application?.provinceId){
                
                    dispatch(fetchDistricts(apiResponse.application?.provinceId?.id))
                }
                if(apiResponse.application?.districtId){
                    dispatch(fetchSectors(apiResponse.application?.districtId?.id))
                }
                if(apiResponse.application?.sectorId){
                    dispatch(fetchCells(apiResponse.application?.sectorId?.id))
                }
                if(apiResponse.application?.cellId){
                    dispatch(fetchVillages(apiResponse.application?.cellId?.id))
                }
                setHasFetched(true)
            }
            
        }
        if(apiResponse.application && apiResponse.application.residenceType === null){
            setApplicationDetails({
                ...apiResponse.application,
                residenceType: 'Local'
            })
        }  
        
    },[apiResponse.application])

    useEffect(()=>{
        dispatch(fetchProvince({data: 'hello'}))
        // dispatch(fetchIndividualApplication(appId))
        if(isMember){
            setApplicationDetails(props.location.state.application)
        }
    },[])



    useEffect(()=>{
        if(apiResponse.edited === requestId){
        history.push({
            pathname: '/membership',
            state: {
                // application: applicationDetails
            }
        })
        }
    },[apiResponse.edited])

    useEffect(()=>{
        if(isMember){
            setApplicationDetails(props.location.state.application)
        }else{
            dispatch(fetchIndividualApplicationReport(appId))
        }
        if(apiResponse.message === requestId){
            history.push('/dashboard')
        }
    },[apiResponse.message])

    var provinceArr 
    if(apiResponse.province && apiResponse.province.length > 0){
        provinceArr = apiResponse.province.map(value=>{
            return {value : value.id, label: value.name}
        })
    }

    var districtsArr
    if(apiResponse.district && apiResponse.district.length > 0){
        districtsArr = apiResponse.district.map(value=>{
            return {value : value.id, label: value.name}
        })
    }
    
    var sectorArr
    if(apiResponse.sector && apiResponse.sector.length > 0){
        sectorArr = apiResponse.sector.map(value=>{
            return {value : value.id, label: value.name}
        })
    }

    var cellArr
    if(apiResponse.cell && apiResponse.cell.length > 0){
        cellArr = apiResponse.cell.map(value=>{
            return {value : value.id, label: value.name}
        })
    }

    var villageArr
    if(apiResponse.village && apiResponse.village.length > 0){
        villageArr = apiResponse.village.map(value=>{
            return {value : value.id, label: value.name}
        })
    }

    const handleSaveForLater = ()=>{
        if(applicationDetails.contactEmail !== null && !validator.isEmail (applicationDetails.contactEmail)){
            setEmailError(true)
            setEmailHelperText("Invalid Email")
            return
        }
        if(applicationDetails.secondaryContactEmail !== null && !validator.isEmail (applicationDetails.secondaryContactEmail)){
            setSecondaryEmailError(true)
            setSecondaryEmailHelperText("Invalid Email")
            return
        }
        const reqId = uuidv4()
        setRequestId(reqId)

        if(applicationId){
            const sentData = {
                ...applicationDetails,
                step: 3
            }
            dispatch(updateIndividualApplication({
                data:{
                    ...sentData
                },
                id:applicationId,
                reqId : reqId
            }))
        }
        else{
            dispatch(submitIndividualApplication({
                data:{
                    ...applicationDetails
                },
                reqId:reqId
            }))
        }
    }
    const handleSubmit = ()=>{
      if(applicationDetails.contactEmail !== null && !validator.isEmail (applicationDetails.contactEmail)){
            setEmailError(true)
            setEmailHelperText("Invalid Email")
            return
        }
        if(applicationDetails.secondaryContactEmail !== null && !validator.isEmail (applicationDetails.secondaryContactEmail)){
            setSecondaryEmailError(true)
            setSecondaryEmailHelperText("Invalid Email")
            return
        }
  
        const reqId = uuidv4()
        setRequestId(reqId)
   
        history.push({
            pathname: '/applicant/educational-details',
            state: {
                application:  applicationDetails
            }
        })
        if(applicationId){
            const sentData = {
                ...applicationDetails,
                step: 3
            }
            dispatch(updateIndividualApplication({
                data:{
                    ...sentData
                },
                id:applicationId,
                reqId : reqId
            }))
        }
        else{
            dispatch(submitIndividualApplication({
                data:{
                    ...applicationDetails
                },
                reqId:reqId
            }))
        }

    }
    const handleCancel = ()=>{
        history.push({
            pathname: '/applicant/personal-details',
            state: {
                application: applicationDetails
            }
        })
    }

    const handleMembership = () =>{
        const reqId = uuidv4()
        setRequestId(reqId)
        const sentItems = {
                cell: applicationDetails.cellId,
                companyEmail: applicationDetails.companyEmail,
                contactEmail: applicationDetails.contactEmail,
                contactTelephoneNumber: applicationDetails.contactTelephoneNumber,
                countryOfResidence: applicationDetails.countryOfResidence,
                district: applicationDetails.districtId,
                id: applicationDetails.id,
                isLocal: applicationDetails.isLocal,
                province: applicationDetails.provinceId,
                residenceAddress: applicationDetails.residenceAddress,
                residenceType: applicationDetails.residenceType,
                secondaryContactEmail: applicationDetails.secondaryContactEmail,
                secondaryContactTelephoneNumber: applicationDetails.secondaryContactTelephoneNumber,
                sector: applicationDetails.sectorId,
                streetOrHouseNumber: applicationDetails.streetOrHouseNumber,
                userId: applicationDetails.userId,
                village: applicationDetails.villageId
        }
        dispatch(editMembership({
            id: appId, 
            application: sentItems,
            reqId : reqId
        }))
     }

     const handlePhoneValidation = (phone, type) =>{
        if(phone&&  phone.length < 6){
            if(type === 'primary'){
                setphoneError({primaryPhone : true})
                setPhoneErrorText({primaryPhone: 'invalid input'})
            }else{
                setphoneError({secondaryPhone: true})
                setPhoneErrorText({secondaryPhone: 'invalid input'})
            }
        }
     }

    
     const handleCloseMembership = ()=>{
        history.goBack()
    }

    return (
        <div>
             {!isMember &&<DashboardHeader 
                activeStep={3}
                application={applicationDetails}
                />}
            <DashBoardContainer
                handleSubmit={handleSubmit}
                handleCancel={handleCancel}
                handleSaveForLater={handleSaveForLater}
                title="Next"
                disabled={actionLoader}
                isFetching={!apiResponse.application}
                loader={actionLoader}
                middleTitle="Save for Later"
                hasCloseBtn={isMember ? true: false}
                hasButton={isMember ? true: false}
                closeTitle="Submit"
                handleClose={handleMembership}
                handleCloseMembership={handleCloseMembership}
                editLoader={apiResponse.editLoader?.isLoading}>
                <div className="first-step-container" >
                    <div style={{
                    width: '50%',}}>
                        <div style={{
                             display: 'flex',
                             alignItems: 'center',
                             flexDirection: 'column',
                        }}>
                            <span className="dashboard-green-text-header">Main contacts</span>
                            <TextField 
                                title="Phone"
                                handleChange={(text)=>{setApplicationDetails({
                                    ...applicationDetails,
                                    contactTelephoneNumber:normalizeInput(text.target.value, applicationDetails.contactTelephoneNumber)
                                })
                                setPhoneErrorText({primaryPhone: ''})
                                setphoneError({primaryPhone: false})
                            }}
                    
                                value={applicationDetails.contactTelephoneNumber}
                                type="tel"
                                onBlur={()=>handlePhoneValidation(applicationDetails.contactTelephoneNumber, 'primary')}
                                error={phoneError.primaryPhone}
                                helperText={phoneErrorText.primaryPhone}
                                required={true}
                                />
                            <TextField 
                                title="Email"
                                handleChange={(text)=>{setApplicationDetails({
                                    ...applicationDetails,
                                    contactEmail:text.target.value
                                })
                                setEmailHelperText('')
                                setEmailError(false)}}
                              
                                value={applicationDetails.contactEmail}
                                type="email"
                                error={emailError}
                                helperText={emailHelperText}
                                required={true}
                                />
                        </div>
                        <div style={{
                             display: 'flex',
                             alignItems: 'center',
                             flexDirection: 'column',
                             marginTop: 10
                        }}>
                            <span className="dashboard-green-text-header">Contacts for next of kin</span>
                            <TextField 
                                required={true}
                                title="Phone"
                                handleChange={(text)=>{setApplicationDetails({
                                    ...applicationDetails,
                                    secondaryContactTelephoneNumber: normalizeInput(text.target.value, applicationDetails.secondaryContactTelephoneNumber)
                                })
                                setPhoneErrorText({secondaryPhone: ''})
                                setphoneError({secondaryPhone: false})
                            }}
                                value={applicationDetails.secondaryContactTelephoneNumber}
                                type="tel"
                                onBlur={()=>handlePhoneValidation(applicationDetails.secondaryContactTelephoneNumber, 'secondary')}
                                error={phoneError.secondaryPhone}
                                helperText={phoneErrorText.secondaryPhone}
                                />
                            <TextField 
                                required={true}
                                title="Email"
                                handleChange={(text)=>
                                    {setApplicationDetails({
                                    ...applicationDetails,
                                    secondaryContactEmail: text.target.value
                                })
                                setSecondaryEmailHelperText('')
                                setSecondaryEmailError(false)}
                            }
                                value={applicationDetails.secondaryContactEmail}
                                type="email"
                                error={secondaryEmailError}
                                helperText={secondaryEmailHelperText}
                                />
                        </div>
                    </div>
                    <div className="vertical-seperator"></div>
                    <div style={{
                        width: '50%'
                        }}>
                            <div style={{
                             display: 'flex',
                             alignItems: 'center',
                             flexDirection: 'column'
                        }}>
                            <span className="dashboard-green-text-header">Residence address</span>
                        <Residence
                                handleTitleChange={(text)=>setApplicationDetails({
                                    ...applicationDetails,
                                    residenceType: text.target.value
                                })}
                                titleValue={applicationDetails?.residenceType}
                            />
                            <>

                            </>
                            {applicationDetails?.residenceType === '' || applicationDetails?.residenceType === 'Local' ? 
                            <>
                            <VerticalSelectField
                                title="Province"
                                options={provinceArr}
                                handleChange={(text)=>{setApplicationDetails({
                                    ...applicationDetails,
                                    provinceId: {
                                        name: text.label,
                                        id: text.value
                                    },
                                    districtId:{
                                        name: '',
                                        id: ''
                                    },
                                    sectorId: {
                                        name: '',
                                        id: ''
                                    },
                                    cellId: {
                                        name: '',
                                        id: ''
                                    },
                                    villageId: {
                                        name: '',
                                        id: ''
                                    }
                                });
                                dispatch(fetchDistricts(text.value));
                                sectorArr=[]
                                cellArr=[]
                                villageArr= []
                            }}
                                selectedOption={{value: applicationDetails.provinceId?.id, label:applicationDetails.provinceId?.name }}
                                required={true}
                                />
                     
                            <VerticalSelectField 
                                title="District"
                                options={districtsArr}
                                handleChange={(text)=>{setApplicationDetails({
                                    ...applicationDetails,
                                    districtId: {
                                        name:text.label,
                                        id:text.value
                                    },
                                    sectorId: {
                                        name: '',
                                        id: ''
                                    },
                                    cellId: {
                                        name: '',
                                        id: ''
                                    },
                                    villageId: {
                                        name: '',
                                        id: ''
                                    }
                                });
                                dispatch(fetchSectors(text.value));
                                cellArr=[]
                                villageArr= []
                            }}
                                selectedOption={{label:applicationDetails.districtId?.name, value:applicationDetails.districtId?.id}}
                                required={true}
                                />
                            <VerticalSelectField 
                                title="Sector"
                                handleChange={(text)=>{setApplicationDetails({
                                    ...applicationDetails,
                                    sectorId: {
                                        name: text.label,
                                        id: text.value
                                    },
                                    cellId: {
                                        name: '',
                                        id: ''
                                    },
                                    villageId: {
                                        name: '',
                                        id: ''
                                    }
                                });
                                dispatch(fetchCells(text.value))
                                villageArr= []
                            }}
                                options={sectorArr}
                                selectedOption={{value: applicationDetails.sectorId?.id, label:applicationDetails.sectorId?.name}}
                                required={true}
                                />
                              <VerticalSelectField 
                                title="Cell"
                                handleChange={(text)=>{setApplicationDetails({
                                    ...applicationDetails,
                                    cellId: {
                                        name: text.label,
                                        id: text.value
                                    },
                                    villageId: {
                                        name: '',
                                        id: ''
                                    }
                                });
                                dispatch(fetchVillages(text.value))
                            }}
                                options={cellArr}
                                selectedOption={{value: applicationDetails.cellId?.id, label:applicationDetails.cellId?.name}}
                                required={true}
                                />
                            <VerticalSelectField 
                                title="Village"
                                handleChange={(text)=>setApplicationDetails({
                                    ...applicationDetails,
                                    villageId: {
                                        name: text.label,
                                        id: text.value
                                    }
                                })}
                                options={villageArr}
                                selectedOption={{value: applicationDetails.villageId?.id, label:applicationDetails.villageId?.name}}
                                required={true}
                                />
                                <TextField 
                                    title="Street/House number"
                                    placeholder="jmugabo@gmail.com"
                                    handleChange={(text)=>setApplicationDetails({
                                        ...applicationDetails,
                                        streetOrHouseNumber: text.target.value
                                    })}
                                    value={applicationDetails.streetOrHouseNumber}/>
                                </> : 
                                        <>
                                    <CountrySelector
                                        required={true}
                                        title="Residence Country"
                                        handleNationality={(value)=>setApplicationDetails({
                                            ...applicationDetails,
                                            countryOfResidence:{
                                                name: value.label,
                                                id: value.value
                                            }
                                        })}
                                        nationality={{value: applicationDetails?.countryOfResidence?.id, label:applicationDetails?.countryOfResidence?.name }}/>
                                    <TextArea 
                                        title="Residence Address"
                                        placeholder="jmugabo@gmail.com"
                                        handleChange={(text)=>setApplicationDetails({
                                            ...applicationDetails,
                                            residenceAddress: text.target.value
                                        })}
                                        value={applicationDetails.residenceAddress}
                                        required={true}
                                        />
                                </>
                            }
                        </div>

                    </div>
                </div>
            </DashBoardContainer>
        </div>
    )
}

export default ApplicationContactDetails